export const PM = "PM";
export const NEO = "NEO";
export const DP = "DP";
export const VP = "VP";
export const IQ = "IQ";
